/* src/app/private/components/user-section/delete-user/delete-user.component.scss */
/*# sourceMappingURL=delete-user.component.css.map */
